var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-item", attrs: { align: "center" } },
    [
      _c(
        "router-link",
        {
          staticClass: "nav-link",
          attrs: {
            to: {
              name: _vm.routerName,
              params: {
                clientId: _vm.$route.params.clientId
              }
            }
          }
        },
        [
          _c("div", { class: _vm.icon }),
          _vm._v(" "),
          _c("div", {}, [
            _c("span", { staticClass: "nav-font-size-small" }, [
              _vm._v(_vm._s(_vm.name))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20f9d174", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20f9d174","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/sidebar/SidebarNavIcons.vue
// module id = 1821
// module chunks = 1